import React, { useEffect } from "react";
import RegistrationForm from "../components/RegistrationForm";
import Loader from "../components/Loader";

import { useAuth } from "../services/hooks/useAuth";
import { usePageTransition } from "../services/hooks/usePageTransition";
import { useRedirect } from "../services/hooks/useRedirect";
import { useGlobal } from "../services/hooks/useGlobal";

export default function register() {
  const { startTransition, completeTransition } = usePageTransition();
  const { user, authStatus, signUp, signUpError, signUpStatus } = useAuth();
  const { redirect } = useRedirect();
  const { setPageTitle } = useGlobal();

  useEffect(() => {
    setPageTitle({
      pageTitle: `Register`,
    });

    return () => {
      setPageTitle({
        pageTitle: null,
      });
    };
  }, []);

  useEffect(() => {
    completeTransition();

    return () => {
      startTransition();
    };
  }, []);

  useEffect(() => {
    if (user || signUpStatus === "success") {
      redirect("/subscribe");
    }
  }, [user, signUpStatus]);

  const onSignUp = (data) => {
    signUp(data);
  };

  if (authStatus !== "ready" || user) {
    return (
      <>
        <Loader absoluteCenter />
      </>
    );
  }

  return (
    <>
      <div className="container w-md-50">
        <div className="card card-lg">
          <div className="card-body">
            <h3 className="mb-7 text-center">Create an Account</h3>

            <hr className="bg-dark" />

            <p className="text-center">
              This allows you to save your profile, customize your
              subscriptions, track your order and enjoy exclusive member perks!
            </p>

            <RegistrationForm
              onSignUp={onSignUp}
              signUpError={signUpError}
              signUpStatus={signUpStatus}
            />
          </div>
        </div>
      </div>
    </>
  );
}
